import { render } from "./FlashSwap.vue?vue&type=template&id=2aac34e9&scoped=true"
import script from "./FlashSwap.vue?vue&type=script&lang=js"
export * from "./FlashSwap.vue?vue&type=script&lang=js"

import "./FlashSwap.vue?vue&type=style&index=0&id=2aac34e9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aac34e9"]])

export default __exports__